import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var current = _ref.current,
      href = _ref.href,
      text = _ref.text;
  var getClassName = getClassNameFactory(BreadcrumbItem.displayName);
  var nameElement = text;

  if (!current) {
    nameElement = /*#__PURE__*/React.createElement("a", {
      className: getClassName({
        descendantName: "inner"
      }),
      href: href
    }, text);
  }

  return current ? /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: "current"
    }),
    "aria-current": "page"
  }, nameElement) : /*#__PURE__*/React.createElement("li", {
    className: getClassName()
  }, nameElement);
};

BreadcrumbItem.displayName = "BreadcrumbItem";
export default BreadcrumbItem;